import '../sass/main.scss';

import { initAuctionFilter } from "./auctionFilter";
import { initOffer } from './auction.js';
import { initTokenLogin } from "./login.js";
import { initMap, showMap } from "./map";
import { initRangeSlider } from "./rangeSlider";
import { syncTime } from './time'
import './sentry.js'
import './infinityPaginator.js'

document.addEventListener('DOMContentLoaded', () => {
    const createAuctionDialog = document.getElementById('createAuctionDialog');
    if (createAuctionDialog) {
        const btnCreateAuction = createAuctionDialog.querySelector('[data-btn-create-auction]');
        const createAuctionForm = createAuctionDialog.querySelector('[data-create-auction-form]');
        const startingPriceInput = createAuctionDialog.querySelector('[data-field-starting-price]');
        const buyNowPriceInput = createAuctionDialog.querySelector('[data-field-buy-now-price]');

        $(createAuctionDialog).on('show.bs.modal', (e) => {
            const btn = e.relatedTarget;
            const coupon = JSON.parse(btn.dataset.coupon);
            const expiration = (new Date(coupon.expiration.date));
            createAuctionDialog.querySelector('[data-valuable-id]').value = coupon.id;
            createAuctionDialog.querySelector('[data-coupon-name] span').textContent = coupon.name;
            createAuctionDialog.querySelector('[data-coupon-expiration] span').textContent = expiration.toLocaleDateString().replace(' ', '');
            createAuctionDialog.querySelector('[data-coupon-value] span').textContent = coupon.cashback_value;
            createAuctionDialog.querySelector('[data-coupon-image]').src = coupon.image_url;

            if (startingPriceInput) {
                startingPriceInput.max = Number(coupon.cashback_value) - 1;
            }
            if (buyNowPriceInput) {
                buyNowPriceInput.max = Number(coupon.cashback_value);
            }

            btnCreateAuction.addEventListener('click', sendCreateAuctionForm)
        })
        $(createAuctionDialog).on('hide.bs.modal', (e) => {
            btnCreateAuction.removeEventListener('click', sendCreateAuctionForm);
        })

        const checkMaxValue = (input) => {
            input.addEventListener('change', (e) => {
                if (input.validity.rangeOverflow) {
                    input.setCustomValidity('Zadaná hodnota nemůže být vyšší než hodnota poukazu.');
                } else {
                    input.setCustomValidity('');
                }

                input.reportValidity();
            })
        }

        checkMaxValue(startingPriceInput);
        checkMaxValue(buyNowPriceInput);

        const sendCreateAuctionForm = (e) => {
            e.preventDefault();

            checkMaxValue(startingPriceInput);
            checkMaxValue(buyNowPriceInput);

            if (startingPriceInput.validity.valid === false || buyNowPriceInput.validity.valid === false) {
                alert('Zadaná hodnota nemůže být vyšší než hodnota poukazu.')
                return;
            }

            if (Nette.validateForm(createAuctionForm)) {
                createAuctionForm.submit();
            }
        }
    }

    const sendToDeviceDialog = document.getElementById('sendToDeviceDialog');
    if (sendToDeviceDialog) {
        const btnConfirm = sendToDeviceDialog.querySelector('[data-btn-confirm-send]');
        $(sendToDeviceDialog).on('show.bs.modal', (e) => {
            const btn = e.relatedTarget;
            const coupon = JSON.parse(btn.dataset.coupon);
            console.log({coupon})
            btnConfirm.coupon = coupon;
            btnConfirm.addEventListener('click', sendToDeviceForm);
        })
        $(sendToDeviceDialog).on('hide.bs.modal', (e) => {
            btnConfirm.removeEventListener('click', sendToDeviceForm);
        })

        const sendToDeviceForm = (e) => {
            const valuableId = e.currentTarget.coupon.id;

            const formData = new FormData();
            formData.append('valuableId', valuableId);
            fetch(sendToDeviceDialog.dataset.sendToDeviceUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json.status === 'ok') {
                        location.reload();
                    } else {
                        alert(json.message);
                    }
                })
        }
    }

    const confirmAuctionBidDialog = $('#confirmAuctionBidDialog');
    if (confirmAuctionBidDialog) {
        const dialogEl = confirmAuctionBidDialog.get(0);
        dialogEl?.querySelector('[data-btn-send-auction-bid]').addEventListener('click', (e) => {
            e.preventDefault()

            const formData = new FormData();
            formData.append('bid', dialogEl.dataset.bidValue);
            formData.append('offerId', dialogEl.dataset.offerId);
            fetch(dialogEl.dataset.sendBidUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((json) => {
                    if (json.status === 'ok') {
                        location.reload();
                    } else {
                        alert(json.message);
                    }
                })
        })
    }

    const confirmAuctionBuyNowDialog = $('#confirmAuctionBuyNowDialog');
    if (confirmAuctionBuyNowDialog) {
        const dialogEl = confirmAuctionBuyNowDialog.get(0);
        dialogEl?.querySelector('[data-btn-send-auction-buy-now]').addEventListener('click', (e) => {
            e.preventDefault()

            const formData = new FormData();
            formData.append('offerId', dialogEl.dataset.offerId);
            fetch(dialogEl.dataset.sendBuyNowUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((json) => {

                    if (json.status === 'ok') {
                        location.reload();
                    } else {
                        alert(json.message);
                    }
                })
        })
    }

    const pubsMapDialog = $('#pubsMapDialog');
    const mapEl = document.querySelector('[data-map]');
    if (mapEl && pubsMapDialog) {
        initMap(mapEl).then(() => {
            const btnsShowPubMap = document.querySelectorAll('[data-btn-open-map]');
            btnsShowPubMap.forEach(el => showMap(el, mapEl, pubsMapDialog));
        })
    }

    const auctionOffers = document.querySelectorAll('[data-auction-offer]')
    auctionOffers.forEach(el => initOffer(el, confirmAuctionBidDialog, confirmAuctionBuyNowDialog))

    const auctionHistoryFilterForm = document.querySelector('[data-filter-history-form]')
    if (auctionHistoryFilterForm) {
        auctionHistoryFilterForm.addEventListener('input', (e) => {
            auctionHistoryFilterForm.submit();
        })
    }

    const auctionFilter = document.querySelector('[data-auction-filter]');
    const auctionSelectedFilter = document.querySelector('[data-auction-selected-filters]');
    if (auctionFilter) {
        initAuctionFilter(auctionFilter, auctionSelectedFilter);
    }

    const rangeSliders = document.querySelectorAll('[data-range-modal]');
    if (rangeSliders) {
        rangeSliders.forEach((el) => initRangeSlider(el));
    }

    const tokenLogins = document.querySelectorAll('[data-token-login-url]');
    if (tokenLogins) {
        for (const tokenLogin of tokenLogins) {
            initTokenLogin(tokenLogin);
        }
    }

    syncTime();
    setInterval(syncTime, 60 * 1000);
})
